export { default } from './ActivityEdit';

